/**
 * A function that takes a length and
 * returns a random string
 * @param  {number} length of the random string
 * @returns {string} random string
 */
const randomSecureString = (length) => {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export default randomSecureString;
